module.exports = __webpack_public_path__ + "img/dentist.c067a10b.png";